import _ from "lodash";

export const formatOrderItems = (items) => {
    return _(items)
        .groupBy("product_netsuite_id")
        .map((groupedItems, productId) => {
            const base = groupedItems[0];

            const {
                quantity,
                product_case_quantity,
                price_level,
                uom,
            } = base;

            const effectiveQuantity =
                uom?.toLowerCase() === "case"
                    ? quantity * product_case_quantity
                    : quantity;

            const applicableItems = groupedItems.filter(
                ({ product_minimum_quantity }) =>
                    product_minimum_quantity <= effectiveQuantity
            );

            const matchedItem =
                _.maxBy(
                    applicableItems.filter(
                        ({ product_price_level }) => product_price_level === price_level
                    ),
                    "product_minimum_quantity"
                ) ?? base;

            // An item that was formatted before carries its tiers already; formatting it again must not drop them.
            const alreadyFormatted = groupedItems.length === 1 && Array.isArray(base.tiers) && base.tiers.length > 0;

            const tiers = alreadyFormatted ? base.tiers : groupedItems.map(
                ({
                    product_price_level,
                    product_tier_price,
                    product_minimum_quantity,
                    product_case_quantity,
                }) => ({
                    price_level: product_price_level,
                    tier_price: product_tier_price,
                    minimum_quantity: product_minimum_quantity,
                    case_quantity: product_case_quantity,
                })
            );

            return {
                ...matchedItem,
                product_netsuite_id: Number(productId),
                tiers,
            };
        })
        .value();
};